import { call, delay, put, race, select, take } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {getCurrentReport} from "../../selectors/patientsSelector";
import {CHECK_REPORT_ERROR, CHECK_REPORT_REQUEST, CHECK_REPORT_STOP, CHECK_REPORT_SUCCESS} from "../../actions";

// Worker Saga: performs the repeated fetch and delay cycle
function* workerCheckReport(): Generator<any> {
  try {
    const currentReport: any = yield select(getCurrentReport);

    if ('id' in currentReport) {
      while (true) {
        const response = yield call(PatientsAPI.checkReport, currentReport.id);
        if (response) {
          yield put({type: CHECK_REPORT_SUCCESS, payload: {currentReport: response}})
          // Wait for 5 seconds before the next poll
          yield delay(1000);
        }
      }
    }
  } catch (error) {
    yield put({ type: CHECK_REPORT_ERROR, error });
  }
}

// Watcher Saga: starts polling and listens for a stop action
export function* watcherCheckReport() {
  while (true) {
    yield take(CHECK_REPORT_REQUEST);
    
    // Run pollData until a STOP_POLLING action is dispatched
    yield race({
      task: call(workerCheckReport),
      cancel: take(CHECK_REPORT_STOP),
    });
  }
}
